import services from "../Constant/service";
import endpoint from "../Constant/endpoint";
import { showSuccessSnackbar } from "./snackbarAction";
import { showErrorSnackbar } from "./snackbarAction";
import { SET, UPDATE } from "../Types/courseTypes";
import { updateValues } from "./authAction";

export const setParentCourse = (key, value) => (dispatch) => {
  dispatch({
    type: SET,
    payload: {
      [key]: value,
    },
  });
};

export const modifyParentCourse = (key, value) => (dispatch) => {
  dispatch({
    type: UPDATE,
    payload: {
      [key]: value,
    },
  });
};

//******************************************************
// Exam Name
// *****************************************************
export const CreateNewExam = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.exam.createExam,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadExamLogo = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.exam.uploadExamLogo,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getExamWithState = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.exam.getExamWithState,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const UpdateExamNew = (examId, data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.exam.updateExamNew + examId,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        if (res?.code) {
          dispatch(showErrorSnackbar(res?.response?.data?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const deleteExam = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.deleteApiCall(
    endpoint.exam.deleteExam,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getExam = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.exam.getExam,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

// *****************************************************
// Sub Exam
// *****************************************************

export const addSubExam = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subExam.addSubExam,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        if (res?.msgCode === "511") {
          dispatch(
            showErrorSnackbar("subExamNames contains a duplicate value"),
          );
        } else if (res?.msgCode === "717") {
          dispatch(showErrorSnackbar(res?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubExamNew = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subExam.getSubExamNew,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const deleteSubExam = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.deleteApiCall(
    endpoint.subExam.deleteSubExam + data,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateSubExamNew = (data, id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.subExam.updateSubExamNew + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res?.data?.data);
      } else {
        if (res?.code) {
          dispatch(showErrorSnackbar(res?.response?.data?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubExamListNew = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.subExam.getSubExamListNew,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubExam = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subExam.getSubExam,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubExamTeacher = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subExam.getSubExam,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

// *****************************************************
// Exam Stream
// *****************************************************
export const addExamStream = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.examStream.addExamStream,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadExamStreamLogo = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.examStream.uploadExamStreamLogo,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getExamStream = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.examStream.getExamStream,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateExamStream = (data, id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.examStream.updateExamStream + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        if (res?.code) {
          dispatch(showErrorSnackbar(res?.response?.data?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const deleteExamStream = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.deleteApiCall(
    endpoint.examStream.deleteExamStream,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

// *****************************************************
// Language
// *****************************************************

export const uploadLanguageLogo = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.language.uploadLanguageLogo,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addLanguage = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.language.addLanguage,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getLanguage = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.language.getLanguage,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const deleteLanguage = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.deleteApiCall(
    endpoint.language.deleteLanguage,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateLanguage = (data, id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.language.updateLanguage + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        if (res?.code) {
          dispatch(showErrorSnackbar(res?.response?.data?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

// *****************************************************
// Sub Category
// *****************************************************

export const uploadSubCategoryIcon = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.subCategory.uploadSubcategoryIcon,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addSubCategory = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subCategory.addSubCategory,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubCategory = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.subCategory.getSubCategory,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const deleteSubCategory = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.deleteApiCall(
    endpoint.subCategory.deleteSubCategory,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateSubCategory = (data, id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.subCategory.uploadSubcategory + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

// *****************************************************
// Subject
// *****************************************************

export const AddSubject = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subject.addSubject,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubjectList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.subject.getSubjectList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const deleteSubjectList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.deleteApiCall(
    endpoint.subject.deleteSubjectList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateSubject = (data, id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.subject.updateSubject + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

//  **************************************************************
//  Main Category
//  ************************************************************
export const addMainCategory = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.mainCategory.addMainCategory,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getMainCategory = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.mainCategory.getMainCategory,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubCategoryByMainCat = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.mainCategory.getSubCategoryByMainCat,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(
          showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
        );
        callback(res?.data?.data);
      } else {
        callback([]);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      callback([]);
      dispatch(updateValues("loader", false));
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
    },
  );
};

export const deleteMainCategory =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      endpoint.mainCategory.deleteMainCategory,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const updateMainCategory =
  (data, id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.mainCategory.updateMainCategory + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

// *****************************************************
// Section
// *****************************************************
export const getSectionTypeList = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.section.getSectionTypeList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addSection =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.section.addSection,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const deleteSection =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      endpoint.section.deleteSection,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const updateSection =
  (data, id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.section.updateSection + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const getStudentData = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.resultCompilation.getStudentData,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        callback(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      callback(false);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadPushNotificationImg =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    let formData = new FormData();
    formData.append("files", data);
    services.postUploadMedia(
      `${endpoint.campaign.uploadPushNotificationImg}`,
      formData,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const sendPushNotificationData =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaign.sendPushNotificationData,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          callback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        callback(false);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const addQuesttionOfTheDay = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.questionOfTheDay.addQuesttionOfTheDay,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getListQuestionOftheday = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.questionOfTheDay.getListQuestionOftheday,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const deleteQuestionOfTheDay =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      endpoint.questionOfTheDay.deleteQuestionOfTheDay,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error, "Error in Topic delete");
      },
    );
  };
export const getQuestionDetails = (id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.questionOfTheDay.getQuestionDetails + id,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(
          showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
        );
        callback(res?.data?.data);
      } else {
        callback("");
        dispatch(showErrorSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg));
      }
    },
    (error) => {
      callback("");
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const UpdateQuestionById = (id, data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.questionOfTheDay.UpdateQuestionById + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res?.data);
      } else {
        callback([]);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      callback([]);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getExtendedTotalUser = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.user.getExtendedTotalUser,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSourceWiseConversionAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.getSourceWiseConversionAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getSourceWiseUserList = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.user.getSourceWiseUserList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getMessagedUserList = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.user.getMessagedUserList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addRecordingServer = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.servers.addRecordingServer,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getAcademicheadExamWiseAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.course.getAcademicheadExamWiseAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const appFeatureUploadMedia = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.appFeatureManagement.appFeatureUploadMedia,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const addAppFeatures =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.appFeatureManagement.addAppFeatures,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const getAppFeatures = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.appFeatureManagement.getAppFeatures,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateAppFeatures = (id, data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.appFeatureManagement.updateAppFeatures + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res?.data);
      } else {
        callback([]);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      callback([]);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const deleteAppFeatures =
  (_id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      endpoint.appFeatureManagement.deleteAppFeatures,
      _id,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.status === services.status_code.success) {
          callback(res);
          dispatch(showSuccessSnackbar(res?.msg ? res?.msg : res?.data?.msg));
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error, "Error in Subject delete");
      },
    );
  };
export const updateStory = (data, params, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    `${endpoint.examShotVideo.updateStory}${params}`,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getStudentSecondTypeUsers =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.getStudentSecondTypeUsers,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getStudentSecondTypeAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.getStudentSecondTypeAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getBDERManagerList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCallCRM(
    endpoint.crm.getBDERManagerList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getBdeTalktime = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCallCRM(
    endpoint.crm.getBdeTalktime,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getStudentThirdTypeAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.getStudentThirdTypeAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getStudentThirdTypeUsers =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.getStudentThirdTypeUsers,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const userKycList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.userKycDetails.userKycList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const userKycUpload = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.userKycDetails.userKycUpload,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const userKycUpdate = (data, params, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    `${endpoint.userKycDetails.userKycUpdate}${params}`,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const UploadResultsCompilation =
  (data, type, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    let formData = new FormData();
    formData.append("file", data);
    services.postUploadMedia(
      endpoint.examResultsCompilation.UploadResultsCompilation + type,
      formData,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const addExamResultCompilation =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.examResultsCompilation.addExamResultCompilation,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getExamsResultCompilation =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.examResultsCompilation.getExamsResultCompilation,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const resultCompilationYearList =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.examResultsCompilation.resultCompilationYearList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const resultCompilationMonthList =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.examResultsCompilation.resultCompilationMonthList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const updateExamsResultCompilation =
  (id, data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.examResultsCompilation.updateExamsResultCompilation + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const resultCompilationReplaceDate = (data) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.examResultsCompilation.resultCompilationReplaceDate,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.status === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getRankPredictionList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.predictionList.getRankPredictionList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getExamPartList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.getExampart.getExamPartList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getUserRankPrediction = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.predictionList.getUserRankPrediction,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getExamTypeSectionList = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.paidAdAutoLead.getExamTypeSectionList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getCategoryWiseAnalysis =
  (params, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.paidAdAutoLead.getCategoryWiseAnalysis,
      params,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const shortVideosAnalysisList = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.shortVideosAnalysis.shortVideosAnalysisList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const birtdayAnalysis = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.birtdayConversionAnalysis.birtdayAnalysis,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getUserActivityList = (params, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.userActivity.getUserActivityList,
    params,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getUserActivityById = (params, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCallCRM(
    endpoint.userActivity.getUserActivityById,
    params,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const campaignBudget = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.campaignBudgetPaidAD.campaignBudget,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const teacherWiseAnalysis = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.teacherAnalysis.teacherWiseAnalysis,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getuserDetailsByStatus = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.user.getuserDetailsByStatus,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getCategories = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.rankPredictorMaster.getCategories,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getSubjects = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.rankPredictorMaster.getSubjects,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const addRankMaster = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.rankPredictorMaster.addRankMaster,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const rankMasterList = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.rankPredictorMaster.rankMasterList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const rankMasterUpdate = (id, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.rankPredictorMaster.rankMasterUpdate + id,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const shortVideosAnalysisUserDetails =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.shortVideosAnalysis.shortVideosAnalysisUserDetails,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const refundTransactionsList = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.refundPayments.refundTransactionsList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const refundTransactionsUpdateStatus =
  (id, data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.refundPayments.refundTransactionsUpdateStatus + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getExamQuestionPartList =
  (data, callback, errorCallback) => async (dispatch) => {
    services.getApiCall(
      endpoint.examSet.getExamQuestionPartList,
      data,
      (res) => {
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res?.data?.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        errorCallback(error);
      },
    );
  };

export const getExamQuestionList = (id, data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.examSet.getExamQuestionList + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getChatbotStageActivity =
  (params, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.chatAnalysis.getChatbotStageActivity,
      params,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getChatbotStageActivityDetails =
  (params, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.chatAnalysis.getChatbotStageActivityDetails,
      params,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getcounsellorChatBotMessages =
  (params, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCallCRM(
      endpoint.chatAnalysis.getcounsellorChatBotMessages,
      params,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const rankMasterGet = (params, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.rankPredictorMaster.rankMasterGet,
    params,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const institutesList = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.rankPredictorMaster.institutesList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const uploadThumbnail = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.liveRecordedVideo.uploadThumbnail,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        callback("");
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
      callback("");
    },
  );
};

export const uploadSubjectAiData = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postUploadMedia(
    endpoint.aiModule.uploadSubjectAiData,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadPyqAiData = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postUploadMedia(
    endpoint.aiModule.uploadPyqAiData,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const submitUploadedData = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.submitUploadedData,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getAIPrompt = (data, callback) => async (dispatch) => {
  // dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.getAIPrompt,
    data,
    (res) => {
      // dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getAIPromptWithUpload =
  (data, payload, callback) => async (dispatch) => {
    let formData = new FormData();
    formData.append("files", data);

    formData.append("isFreeUser", payload.isFreeUser);
    formData.append("isPracticeTest", payload.isPracticeTest);
    formData.append("isPYQ", payload.isPYQ);
    formData.append("systemPrompt", JSON.stringify(payload.systemPrompt));
    formData.append("prompt", JSON.stringify(payload.prompt));
    formData.append("mode", payload.mode);

    const apiEndpoint =
      data?.type === "application/pdf"
        ? endpoint.aiModule.getExtractQuestion
        : endpoint.aiModule.getExtractQuestionFromDocs;

    services.postUploadMedia(
      apiEndpoint,
      formData,
      (res) => {
        if (res?.statusCode === services.status_code.success) {
          callback(res);
          dispatch(showSuccessSnackbar(res?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(
            error?.data?.msg || error?.msg || "Something went wrong",
          ),
        );
      },
    );
  };

export const getExtractDocxQuestion =
  (data, payload, callback) => async (dispatch) => {
    let formData = new FormData();
    formData.append("files", data);

    formData.append("isFreeUser", payload.isFreeUser);
    formData.append("isPracticeTest", payload.isPracticeTest);
    formData.append("isPYQ", payload.isPYQ);
    formData.append("systemPrompt", JSON.stringify(payload.systemPrompt));
    formData.append("prompt", JSON.stringify(payload.prompt));
    formData.append("mode", payload.mode);

    const apiEndpoint = endpoint.aiModule.getExtractDocxQuestion;

    services.postUploadMedia(
      apiEndpoint,
      formData,
      (res) => {
        if (res?.statusCode === services.status_code.success) {
          callback(res);
          dispatch(showSuccessSnackbar(res?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(
            error?.data?.msg || error?.msg || "Something went wrong",
          ),
        );
      },
    );
  };

// Validates a docx file against SOP rules before extraction is allowed to
// run. `errorCallback` is invoked both when the API reports the file as
// invalid and on a network/exception failure, so the caller can surface
// the SOP violation locally (e.g. its own extraction log panel) in
// addition to the snackbar shown here.
// Unlike most endpoints in this file, docx-validate does NOT reply with
// the app's usual {statusCode, data, msg} envelope — it returns its own
// validation-report shape directly: { ok, fileName, summary, stats,
// issues: [{ code, severity, message, fix, ... }] }. So the success
// callback here just hands that raw report to the caller, which branches
// on `res.ok` itself; `errorCallback` is reserved for genuine
// network/HTTP failures (via postUploadMedia's own error path).
export const docxValidate =
  (data, callback, errorCallback) => async (dispatch) => {
    let formData = new FormData();
    formData.append("files", data);

    services.postUploadMedia(
      endpoint.aiModule.docxValidate,
      formData,
      (res) => {
        callback(res);
      },
      (error) => {
        dispatch(
          showErrorSnackbar(
            error?.data?.msg || error?.msg || "Something went wrong",
          ),
        );
        if (errorCallback) errorCallback(error);
      },
    );
  };
export const getPatternDetailList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.getPatternDetailList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadAIFiles = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.aiModule.uploadAIFiles,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

// `errorCallback` is optional — callers that chain several saves (e.g. Save
// All in QuestionExtractor) use it to know a save failed and stop.
export const addExamSetWithQuestions =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiModule.addExamSetWithQuestions,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
          dispatch(showSuccessSnackbar(res?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.msg));
          if (errorCallback) errorCallback(res);
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        if (errorCallback) errorCallback(error);
      },
    );
  };

export const addPYQExamQuestions = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.addPYQExamQuestions,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
        dispatch(showSuccessSnackbar(res?.msg));
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const AiExamQuestionsData = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.AiExamQuestionsData,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadAiJsonFiles = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.aiModule.uploadAiJsonFiles,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addStoreKnowledgeBaseAIData =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiModule.addStoreKnowledgeBaseAIData,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const userProfileActiveList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.userProfileVerification.userProfileActiveList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const userVerification = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.userProfileVerification.userVerification,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        if (res?.code) {
          dispatch(showErrorSnackbar(res?.response?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      }
    },
    (error) => {
      dispatch(showErrorSnackbar(error?.msg ? error?.msg : error?.msg));
      dispatch(updateValues("loader", false));
    },
  );
};

export const getAISimplePrompt = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCallNew(
    endpoint.aiModule.getAISimplePrompt,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadAiImageFiles = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.aiModule.uploadAiImageFiles,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getSubjectWiseKnowledgeListByID =
  (id, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.getApiCall(
      endpoint.aiModule.getSubjectWiseKnowledgeListByID + id,
      "",
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          callback(res?.data?.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getSubjectWiseKnowledgeList = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.aiModule.getSubjectWiseKnowledgeList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const uploadAIBooks =
  (data, uploadToNewFolder, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    let formData = new FormData();
    formData.append("file", data);
    formData.append("uploadToNewFolder", uploadToNewFolder);

    services.postUploadMedia(
      endpoint.aiModule.uploadAIBooks,
      formData,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const addBooksknowledge = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.addBooksknowledge,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addPYQAnalysis = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.addPYQAnalysis,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getAIQuesContextPrompt = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCallNew(
    endpoint.aiModule.getAIQuesContextPrompt,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getVerifyAIQuestions = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCallNew(
    endpoint.aiModule.getVerifyAIQuestions,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getSubjectWiseBooksDetails =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiModule.getSubjectWiseBooksDetails,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getSubjectWiseBooksDetailsById =
  (id, data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiModule.getSubjectWiseBooksDetailsById + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
          callback([]);
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const uploadBookImage = (data, s3Url, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data); // file object
  formData.append("s3Url", JSON.stringify(s3Url?.img)); // string
  services.postUploadMedia(
    endpoint.aiModule.uploadBookImage,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
        dispatch(showSuccessSnackbar(res?.msg));
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      // dispatch(
      //   showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      // );
      dispatch(updateValues("loader", false));
    },
  );
};
export const updateSubjectWiseExams =
  (id, data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.aiModule.updateSubjectWiseExams + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getPYQanalysis = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.getPYQanalysis,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const uploadImageZipFolder = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data); // file object
  services.postUploadMedia(
    endpoint.aiModule.uploadImageZipFolder,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        // dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateTextData = (id, data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.aiModule.updateTextData + id,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        if (res?.code) {
          dispatch(showErrorSnackbar(res?.response?.data?.msg));
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getKnowledgeBaseData = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.getKnowledgeBaseData,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const updatePyqpaperAnalysis =
  (id, data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.aiModule.updatePyqpaperAnalysis + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getAllBooks = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.aiModule.getAllBooks,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getTeacherTaskListForWorkDuration =
  (id, data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.teacherTaskPlan.getTeacherTaskListForWorkDuration + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const toppersTalkAssignBatch = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.toppersTalks.toppersTalkAssignBatch,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getExtractQuestion = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCallNew(
    endpoint.aiModule.getExtractQuestion,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getDoubletickCustomerDetails =
  (params, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCallCRM(
      endpoint.crm.getDoubletickCustomerDetails,
      params,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const doubletickAssignChat = (params, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCallCRM(
    endpoint.crm.doubletickAssignChat,
    params,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const doubletickAddCustomFields =
  (params, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCallCRM(
      endpoint.crm.doubletickAddCustomFields,
      params,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getuserSubscriptionAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.userSubscriptionAnalysis.getuserSubscriptionAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getResultCompilationgImagesList =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.getResultCompilation.getResultCompilationgImagesList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getResultCompilationgSwapImage =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.getResultCompilation.getResultCompilationgSwapImage,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const resultCompilationUploadScoreCard =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    let formData = new FormData();
    formData.append("file", data);
    services.postUploadMedia(
      endpoint.examResultsCompilation.resultCompilationUploadScoreCard,
      formData,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
          errorCallback?.(res);
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const getOrderBreakdownBySegment =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.userSubscriptionAnalysis.getOrderBreakdownBySegment,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const getCourseEnrolledUsers = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.studentMigration.getCourseEnrolledUsers,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const migrateSubscribers = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.studentMigration.migrateSubscribers,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getVerificationLectures = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.linKManagement.getVerificationLectures,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getLecturesLinkReferences =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.linKManagement.getLecturesLinkReferences,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          // dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };

export const updateVerifiedLecturesLink =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.linKManagement.updateVerifiedLecturesLink,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          // dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const addNotes = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.notes.addNotes,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const listStudyNotes = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.notes.listStudyNotes,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        // dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const createAiFaq =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiFaqs.createAiFaq,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          // dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const aiFaqsList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiFaqs.aiFaqsList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          // dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };

export const updateAiFaq =
  (id, data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.putApiCall(
      endpoint.aiFaqs.updateAiFaq + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const deleteAiFaq =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.aiFaqs.deleteAiFaq,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(showErrorSnackbar(error?.msg ? error?.msg : error?.msg));
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const uploadStudyNotesDoc =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    let formData = new FormData();
    formData.append("file", data);
    services.postUploadMedia(
      endpoint.notes.uploadStudyNotesDoc,
      formData,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
          if (errorCallback) errorCallback(res);
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        if (errorCallback) errorCallback(error);
      },
    );
  };
export const uploadStudyDocument = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  let formData = new FormData();
  formData.append("file", data);
  services.postUploadMedia(
    endpoint.notes.uploadStudyDocument,
    formData,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const addTargettingExam =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.targettingExams.addTargettingExam,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const listTargettingExam =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.targettingExams.listTargettingExam,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const updateTargettingExam =
  (id, data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.targettingExams.updateTargettingExam + id,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          if (res?.code) {
            dispatch(showErrorSnackbar(res?.response?.data?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };

export const targetingExamAnalysisList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.targettingExams.targetingExamAnalysisList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const getExamYears = (callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.targettingExams.getExamYears,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const addExtractedNotes =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.notes.addExtractedNotes,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          // dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
          if (errorCallback) errorCallback(res);
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        if (errorCallback) errorCallback(error);
      },
    );
  };

export const translateStudyNoteToHindi =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.notes.translateStudyNoteToHindi,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
          if (errorCallback) errorCallback(res);
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        if (errorCallback) errorCallback(error);
      },
    );
  };

export const getInactiveCourseList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.linKManagement.getInactiveCourseList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          errorCallback(res);
          if (res?.msgCode === "533") {
            dispatch(showErrorSnackbar(res?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const bookSales =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.bookSalesAnalysis.bookSales,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res?.data);
        } else {
          errorCallback(res);
          if (res?.msgCode === "533") {
            dispatch(showErrorSnackbar(res?.msg));
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const getCronList = (callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.cronManagements.cronList,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        errorCallback?.(res?.data);
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
      errorCallback?.(error);
    },
  );
};

export const executeCron =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.cronManagements.cronListExecute,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };

export const sendLiveLecturePushNotification =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.liveClassSchedule.sendLiveLecturePushNotification,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
